import React from 'react';
import Form from '../Components/Form/Form';
import QrCode from '../Images/qr.svg';

export default class Support extends React.Component {
    render(){
        return(
            <React.Fragment>
                <div className="support">
                    <div className="s_left">
                        <Form/>
                    </div>
                    <div className="s_mid">
                        <h2 className="form_title">Support <span>Us</span> | By <span>Code</span></h2>
                        <div className="mid_data">
                            <a href="https://github.com/suryapratapsinghsuryavanshi/solverjs" target="_blank">
                                <h3>Make Contribution</h3>
                            </a>
                            <p>Suggest new features and your view about the SolverJs.</p>
                            <a href="https://www.npmjs.com/package/solverjs" target="_blank">
                                <button className="btn-secondary">SolverJs</button>
                            </a>
                        </div>
                    </div>
                    <div className="s_right">
                        <h2 className="form_title">Support <span>Us</span> | By <span>Wealth</span></h2>
                        <div className="qr_code">
                            <img src={QrCode} alt="qr_code" draggable="false"/>
                        </div>
                        <div className="qr_data">
                            <p id="name">suryprtaps<span>@oksbi</span></p>
                            <p id="upi">All <span>UPI</span> transactions Accepted</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}